import store from '@/store'

let map;
export let placeSearch;
var markerList = [];
var scattermarkers = []//散点气泡
let defaultCenter = [116.414675,39.63148];//默认中心
var OverlayGroup = null;

// 创建地图
export const map_init = (id, jdwd) => {
    map = new AMap.Map(id, {
        resizeEnable: true,
    });
    // map.on("click", function (e) {
    //     // map.setCenter(val);
    //     // addMarker(e.lnglat.lng,e.lnglat.lat)
    //     store.state.lnglat = [e.lnglat.lng, e.lnglat.lat];
    //     for (var i = 0; i < markerList.length; i++) {
    //         map.remove(markerList[i])
    //     }
    //     var marker = new AMap.Marker({
    //         // icon: "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png",
    //         position: [e.lnglat.lng, e.lnglat.lat],
    //         offset: new AMap.Pixel(-13, -30),
    //         icon: new AMap.Icon({
    //             image: "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png",
    //             size: new AMap.Size(30, 40),  //图标所处区域大小
    //             imageSize: new AMap.Size(30, 40) //图标大小
    //         })
    //     });
    //     markerList.push(marker)
    //     marker.setMap(map);
    //     AMap.plugin('AMap.Geocoder', function () {
    //         var geocoder = new AMap.Geocoder({
    //             radius: 1000,
    //             extensions: "all"
    //         });
    //         geocoder.getAddress([e.lnglat.lng, e.lnglat.lat], function (status, result) {
    //             if (status === 'complete' && result.info === 'OK') {
    //                 store.state.addressName = result.regeocode.formattedAddress;
    //             }
    //         });
    //     })
    //
    // });
    // OverlayGroup = new AMap.OverlayGroup();
    map.on("complete", function () {
        setMapCenter(defaultCenter, 13)
    });
    AMap.plugin([
        'AMap.ToolBar',
    ], function () {
        // 在图面添加工具条控件，工具条控件集成了缩放、平移、定位等功能按钮在内的组合控件
        map.addControl(new AMap.ToolBar({
            // 简易缩放模式，默认为 false
            liteStyle: true
        }));
    });

}
export const setMapCenter = (val, zoom) => {
    map.setCenter(val);
    if (zoom) {
        map.setZoom(zoom)
    }
}

export const addMarkerForCoordinate = (lngLats) => {
    // OverlayGroup.clearOverlays();
    addMarker(lngLats);
    map.setCenter(lngLats[0]);
    // let marker = addMarker(lon,lat,data);
    // var infoWindow = new AMap.InfoWindow({
    //     anchor: 'bottom-center',
    //     // isCustom: true,  //使用自定义窗体
    //     content:  createInfoWindow(marker.getExtData()),
    //     offset: new AMap.Pixel(20, -15),
    //     closeWhenClickMap:true
    // });
    // marker.on("click",function () {
    //     infoWindow.open(map, marker.getPosition());
    // })
}

//工单落点
let gdMarkerList = []
let cluster

export function gdMarker(lngLats) {
    for (var i = 0; i < gdMarkerList.length; i++) {
        map.remove(gdMarkerList[i])
    }
    map.clearInfoWindow();
    // if(gdMarkerList.length>0){
    //     // map.remove(gdMarkerList)
    //     map.clearMap()
    // }
    gdMarkerList = []
    if (lngLats.length > 0) {
        // setMapCenter([lngLats[0].gdFsdzJd, lngLats[0].gdFsdzWd], 13)
        lngLats.map(item => {
            gdMarkerList.push(addGdMarker(item))
        })
        // new AMap.MarkerClusterer(map, gdMarkerList, {
        //     renderClusterMarker: function (Object) {
        //         Object.marker.setContent("<div style='text-align:center;line-height:50px;height:50px;width: 50px; font-size: 16px;font-weight: bold;color: rgba(255,255,255,1);border-radius: 50%;background: #7581F8;'>" + Object.count + "</div>") //设置文本标注内容
        //     },
        //     gridSize: 200
        // });
        // new AMap.MarkerCluster(map, gdMarkerList, {
        //     renderMarker: function (Object) {
        //         debugger
        //         Object.marker.setContent("<div style='text-align:center;line-height:40px;height:40px;width: 40px; font-size: 16px;font-weight: bold;color: rgba(255,255,255,1);border-radius: 50%;background: #7581F8;'>" + Object.count + "</div>") //设置文本标注内容
        //     },
        //     gridSize: 200
        // });

    }
    if (cluster) {
        cluster.setMap(null);
    }
    cluster = new AMap.MarkerClusterer(map, gdMarkerList, {
        renderClusterMarker: function (Object) {
            Object.marker.setContent("<div style='text-align:center;line-height:50px;height:50px;width: 50px; font-size: 16px;font-weight: bold;color: rgba(255,255,255,1);border-radius: 50%;background: #7581F8;'>" + Object.count + "</div>") //设置文本标注内容
        },
        gridSize: 60,
        maxZoom:14
    });
}


function addGdMarker(item) {
    // 创建一个 Icon
    var icon = new AMap.Icon({
        // 图标尺寸
        size: new AMap.Size(42, 44),
        // 图标的取图地址
        image: require("../../assets/images/dwdw@1x.png"),
        // 图标所用图片大小
        imageSize: new AMap.Size(42, 44),
        // 图标取图偏移量
        // imageOffset: new AMap.Pixel(-21, -44)
    });

    var marker = new AMap.Marker({
        position: [item.gdFsdzJd, item.gdFsdzWd],
        icon: icon,
        // extData: data,
        offset: new AMap.Pixel(-21, -44)
    });
    var infoWindow = new AMap.InfoWindow({offset: new AMap.Pixel(0, -60)});
    var html = '<div class="mapInfoWindow"><div class="mapInfoWindow_top">';
    html += '<div class="mapInfoWindow_top_left"><p>' + item.gdBt + '</p><p>' + item.gdGdbh + '</p></div>';
    html += '<div class="mapInfoWindow_top_right"><div></div><span>' + item.formKey + '</span></div></div>';
    html += '<div class="mapInfoWindow_bottom">'
    html += '<div class="apInfoWindow_village"><img src="' + require("../../assets/images/building_1_line@1x.png") + '" alt=""><span>' + item.gdSbdwmc + '</span></div>';
    html += '<div class="apInfoWindow_location"><img src="' + require("../../assets/images/location_line@1x.png") + '" alt=""><span>' + item.gdFsdz + '</span></div>';
    html += '<div class="mapInfoWindow_btn" onclick="detailsClick(\'' + item.gdGdbh + '\',\'' + item.gdId + '\')"><img src="' + require("../../assets/images/LeftIcon@1x.png") + '" alt="" >详情</div></div></div>';
    marker.content = html;

    marker.on('click', markerClick);

    function markerClick(e) {
        for (var i = 0; i < gdMarkerList.length; i++) {
            gdMarkerList[i].setIcon(icon)
        }
        map.clearInfoWindow();
        setMapCenter([item.gdFsdzJd, item.gdFsdzWd])
        // console.log(marker)
        // debugger
        e.target.setIcon(new AMap.Icon({
            // 图标尺寸
            size: new AMap.Size(60, 60),
            // 图标的取图地址
            image: require("../../assets/images/map_pin_gd.png"),
            // 图标所用图片大小
            imageSize: new AMap.Size(60, 60),
            // 图标取图偏移量
            // imageOffset: new AMap.Pixel(-30, -60)
        }))
        marker.setOffset(new AMap.Pixel(-30, -60))
        infoWindow.setContent(e.target.content);
        infoWindow.open(map, e.target.getPosition());
    }

    // marker.setLabel({
    //     offset: new AMap.Pixel(0, -10),  //设置文本标注偏移量
    //     content: "<div style='padding:0 4px;line-height:16px;height:20px; font-size: 14px;font-weight: bold;color: rgba(255,255,255,1);border-radius: 2px;background: rgba(0,0,0,0.4);border: 1px solid rgba(0,0,0,0.3);'>我是 marker 的 label 标签</div>", //设置文本标注内容
    //     direction: 'right' //设置文本标注方位
    // });
    return marker;
}

window.detailsClick = function (gdGdbh, gdId) {
    store.commit('addLeftTreeToHeaderTab', {
        name: "Hotline",
        label: gdGdbh,
        linkTo: "/Hotline",
        query: {
            gdId: gdId
        },
    });
}

//人员落点
export function ryMarker(lngLats) {
    if (cluster) {
        cluster.setMap(null);
    }
    for (var i = 0; i < gdMarkerList.length; i++) {
        map.remove(gdMarkerList[i])
    }
    map.clearInfoWindow();
    // if(gdMarkerList.length>0){
    //     // map.remove(gdMarkerList)
    //     map.clearMap()
    // }
    // // map.clearMap()
    gdMarkerList = []
    if (lngLats.length > 0) {
        // setMapCenter([lngLats[0].jd, lngLats[0].wd], 13)
        lngLats.map(item => {
            gdMarkerList.push(addRyMarker(item))
        })
        // new AMap.MarkerClusterer(map, gdMarkerList, {
        //     renderClusterMarker: function (Object) {
        //         Object.marker.setContent("<div style='text-align:center;line-height:40px;height:40px;width: 40px; font-size: 16px;font-weight: bold;color: rgba(255,255,255,1);border-radius: 50%;background: #7581F8;'>" + Object.count + "</div>") //设置文本标注内容
        //     },
        //     gridSize: 200
        // });
    }
    map.add(gdMarkerList);
}

function addRyMarker(item) {
    // 创建一个 Icon
    var icon = new AMap.Icon({
        // 图标尺寸
        size: new AMap.Size(42, 44),
        // 图标的取图地址
        image: require("../../assets/images/map_pin_ryld.png"),
        // 图标所用图片大小
        imageSize: new AMap.Size(42, 44),
        // 图标取图偏移量
        // imageOffset: new AMap.Pixel(-21, -44)
    });

    var marker = new AMap.Marker({
        position: [item.jd, item.wd],
        icon: icon,
        // extData: data,
        offset: new AMap.Pixel(-21, -44),
        id: item.id
    });
    marker.on('click', markerClick);

    function markerClick(e) {
        for (var i = 0; i < gdMarkerList.length; i++) {
            gdMarkerList[i].setIcon(icon)
        }
        setMapCenter([item.jd, item.wd])
        marker.setIcon(new AMap.Icon({
            // 图标尺寸
            size: new AMap.Size(54, 56),
            // 图标的取图地址
            image: require("../../assets/images/map_pin_person.png"),
            // 图标所用图片大小
            imageSize: new AMap.Size(54, 56),
            // 图标取图偏移量
            // imageOffset: new AMap.Pixel(-30, -60)
        }))
        marker.setOffset(new AMap.Pixel(-27, -56))
        window.ryTreeChild(item.id, false)
    }

    // marker.setLabel({
    //     offset: new AMap.Pixel(0, -10),  //设置文本标注偏移量
    //     content: "<div style='padding:0 4px;line-height:16px;height:20px; font-size: 14px;font-weight: bold;color: rgba(255,255,255,1);border-radius: 2px;background: rgba(0,0,0,0.4);border: 1px solid rgba(0,0,0,0.3);'>我是 marker 的 label 标签</div>", //设置文本标注内容
    //     direction: 'right' //设置文本标注方位
    // });
    return marker;
}

//点击人员列表树，改变对应地图落点的图标样式
export function ryMarkClick(item, dkTime, id) {
    let marker;
    if (dkTime) {
        map.setCenter(item);
        gdMarkerList.map(val => {
            // if (val.w.position.lng.toFixed(6) == Number(item[0]).toFixed(6) && val.w.position.lat.toFixed(6) == Number(item[1]).toFixed(6)) {
            //     marker = val;
            // }
            if (val.w.id == id) {
                marker = val;
            }
        })

        if (marker) {
            marker.setIcon(new AMap.Icon({
                // 图标尺寸
                size: new AMap.Size(54, 56),
                // 图标的取图地址
                image: require("../../assets/images/map_pin_person.png"),
                // 图标所用图片大小
                imageSize: new AMap.Size(54, 56),
                // 图标取图偏移量
                // imageOffset: new AMap.Pixel(-30, -60)
            }))
            marker.setOffset(new AMap.Pixel(-27, -56))
        }
    }
}

//清除轨迹点
export function clearGjMarker() {
    map.remove(gdMarkerList)
    gdMarkerList = [];
}

//轨迹落点
let gjMarkerList = []

export function gjMarker(lngLats) {
    for (var i = 0; i < gdMarkerList.length; i++) {
        map.remove(gdMarkerList[i])
    }
    map.clearInfoWindow();
    // map.clearMap()
    // if(gdMarkerList.length>0){
    //     // map.remove(gdMarkerList)
    //     map.clearMap()
    // }
    gdMarkerList = []
    if (lngLats.length < 1) {
        return
    }
    // setMapCenter([lngLats[0].jd, lngLats[0].wd], 14)

    lngLats.map(item => {
        gdMarkerList.push(addGjMarker(item))
        gjMarkerList.push(addGjMarker(item))
    })
    // new AMap.MarkerClusterer(map, gdMarkerList, {
    //     renderClusterMarker: function (Object) {
    //         Object.marker.setContent("<div style='text-align:center;line-height:40px;height:40px;width: 40px; font-size: 16px;font-weight: bold;color: rgba(255,255,255,1);border-radius: 50%;background: #7581F8;'>" + Object.count + "</div>") //设置文本标注内容
    //     },
    //     gridSize: 200
    // });
    map.add(gdMarkerList);

}

function addGjMarker(item) {
    // 创建一个 Icon
    let iconImage;
    if (item.type == 1) {
        iconImage = require("../../assets/images/map_pin_ryld.png")
    } else if (item.type == 2) {
        iconImage = require("../../assets/images/dwdw@1x.png")
    } else if (item.type == 3) {
        iconImage = require("../../assets/images/map_pin_dkxcx.png")
    }
    var icon = new AMap.Icon({
        // 图标尺寸
        size: new AMap.Size(42, 44),
        // 图标的取图地址
        image: iconImage,
        // 图标所用图片大小
        imageSize: new AMap.Size(42, 44),
        // 图标取图偏移量
        // imageOffset: new AMap.Pixel(-21, -44)
    });
    var marker = new AMap.Marker({
        position: [item.jd, item.wd],
        icon: icon,
        // extData: data,
        offset: new AMap.Pixel(-21, -44),
        id: item.id
    });
    marker.setLabel({
        offset: new AMap.Pixel(0, -5),  //设置文本标注偏移量
        content: "<div style='padding:0 4px;line-height:16px;height:20px; font-size: 14px;font-weight: bold;color: rgba(255,255,255,1);border-radius: 2px;background: rgba(0,0,0,0.4);border: 1px solid rgba(0,0,0,0.3);'>" + item.time + "</div>", //设置文本标注内容
        direction: 'right' //设置文本标注方位
    });
    var infoWindow = new AMap.InfoWindow({offset: new AMap.Pixel(0, -44)});
    var html = '<div class="mapInfoWindow"><div class="mapInfoWindow_top">';
    html += '<div class="mapInfoWindow_top_left"><p>' + item.gdBt + '</p><p>' + item.gdGdbh + '</p></div>';
    html += '<div class="mapInfoWindow_top_right"><div></div><span>' + item.formKey + '</span></div></div>';
    html += '<div class="mapInfoWindow_bottom">'
    html += '<div class="apInfoWindow_village"><img src="' + require("../../assets/images/building_1_line@1x.png") + '" alt=""><span>' + item.gdSbdwmc + '</span></div>';
    html += '<div class="apInfoWindow_location"><img src="' + require("../../assets/images/location_line@1x.png") + '" alt=""><span>' + item.gdFsdz + '</span></div>';
    html += '<div class="mapInfoWindow_btn" onclick="detailsClick(\'' + item.gdGdbh + '\',\'' + item.id + '\')"><img src="' + require("../../assets/images/LeftIcon@1x.png") + '" alt="" >详情</div></div></div>';
    marker.content = html;
    if(item.type == 2){
        marker.on('click', markerClick);
    }
    function markerClick(e) {
        map.clearInfoWindow();
        setMapCenter([item.jd, item.wd])
        infoWindow.setContent(e.target.content);
        infoWindow.open(map, e.target.getPosition());
    }
    return marker;
}

//点击个人轨迹列表对应的marker图标变大
export function tableClickToGjMarker(param) {
    let marker;
    if(!(param.gdFsdzJd&&param.gdFsdzWd)){
        return
    }
    setMapCenter([param.gdFsdzJd, param.gdFsdzWd], 16)
    gdMarkerList.map(val => {
        if (val.w.id == param.gdId) {
            marker = val;
        }
        val.setIcon(new AMap.Icon({
            // 图标尺寸
            size: new AMap.Size(42, 44),
            // 图标的取图地址
            image: val.w.icon.w.image,
            // 图标所用图片大小
            imageSize: new AMap.Size(42, 44),
        }))
    })
    if (marker) {
        marker.setIcon(new AMap.Icon({
            // 图标尺寸
            size: new AMap.Size(62, 66),
            // 图标的取图地址
            image: marker.w.icon.w.image,
            // 图标所用图片大小
            imageSize: new AMap.Size(62, 66),
        }))
        marker.setOffset(new AMap.Pixel(-31, -66))
    }
}

//关闭信息窗体
function closeInfoWindowAAA() {
    map.clearInfoWindow();
}

export function add(res){
    if(!map) return
    map.add(res)
}
